<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
            <template v-slot:body>
                <b-overlay :show="loading" rounded="sm">
                    <b-row class="details">
                <b-col lg="12" sm="12">
                    <b-row>
                        <b-col lg="12" sm="12">
                            <b-row>
                                <b-col lg="12" sm="12">
                                    <div style="font-size: 16px; background-color: rgb(51, 121, 130);"><h5 class="text-white text-center">{{$t('ds_institute_management.library_book_receive')}}</h5></div>
                                    <b-table-simple striped bordered small hover class="mb-5">
                                       <tbody>
                                            <b-tr>
                                                <b-td>{{$t('ds_institute_management.organization_name')}}</b-td>
                                                <b-td>{{ getOrgName(data.org_id) }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td>{{$t('ds_institute_management.institute_type')}}</b-td>
                                                <b-td>{{ getInstituteType(data.office_type_id) }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td>{{$t('ds_institute_management.institute_name')}}</b-td>
                                                <b-td>{{ getOfficeName(data.office_id) }}</b-td>
                                            </b-tr>
                                       </tbody>
                                       <tbody>
                                           <b-tr>
                                               <b-td>{{ $t('ds_institute_management.class')}}</b-td>
                                               <b-td>{{ getClassName(data.class_id) }}</b-td>
                                           </b-tr>
                                            <b-tr>
                                                <b-td>{{ $t('ds_institute_management.student_name')}}</b-td>
                                                <b-td>{{ ($i18n.locale === 'bn') ? data.student_info.name_bn : data.student_info.name_en }}</b-td>
                                            </b-tr>
                                           <b-tr>
                                               <b-td>{{ $t('ds_institute_management.student_id')}}</b-td>
                                               <b-td>{{ $n(data.student_info.student_id, { useGrouping: false })  }}</b-td>
                                           </b-tr>
                                            <b-tr>
                                                <b-td>{{ $t('ds_institute_management.distribution_date')}}</b-td>
                                                <b-td>{{ data.distribution_date | dateFormat }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td>{{ $t('ds_institute_management.recieve_date')}}</b-td>
                                                <b-td>{{ data.receive_date | dateFormat }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td>{{ $t('ds_institute_management.remarks')}}</b-td>
                                                <b-td>{{ ($i18n.locale === 'bn') ? data.remarks_bn : data.remarks }}</b-td>
                                            </b-tr>
                                            <b-tr v-if="booklist">
                                                <b-td style="width: 50% !important;">{{ $t('ds_institute_management.book_name')}}</b-td>
                                                <b-td style="width: 50% !important;">
                                                    <ol style="list-style-type: none">
                                                        <li v-for="(item, index) in data.details" :key="index">
                                                            {{ $n(index+1) + '. ' + getBookName(item.book_id) }}
                                                        </li>
                                                    </ol>
                                                </b-td>
                                            </b-tr>
                                       </tbody>
                                    </b-table-simple>
                                </b-col>
                            </b-row>
                            <div class="row">
                                <div class="col-sm-3"></div>
                                <div class="col text-right">
                                    <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-detail')">{{ $t('globalTrans.close') }}</b-button>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
                </b-overlay>
            </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '../../../../../config/pluginInit'
export default {
    name: 'FormLayout',
    props: ['id'],
    components: {
    },
    created () {
        // this.loading = true
          if (this.id) {
              const tmp = this.getData()
              this.data = tmp
          }
    },
    mounted () {
        core.index()
    },
    data () {
        return {
            ItemShow: false,
            saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
            predata: [],
            loading: false,
            classlist: [],
            booklist: [],
            applicantlist: [],
            data: {
                org_id: '',
                office_type_id: '',
                office_id: '',
                student_id: '',
                student_name: '',
                class_id: '',
                distribution_date: '',
                receive_date: '',
                remarks: '',
                remarks_bn: '',
                details: []
            }
        }
    },
    computed: {
        orgList: function () {
            return this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0)
        }
    },
    watch: {
    },
    methods: {
        getofficeTypeList (orgId = null) {
            const instituteTypeList = this.$store.state.commonObj.officeTypeList.filter(item => item.status === 0)
            if (orgId) {
                return instituteTypeList.filter(institute => institute.org_id === orgId)
            }
            return instituteTypeList
        },
        getOfficeList (typeId = null) {
            const instituteList = this.$store.state.commonObj.officeList.filter(item => item.status === 0)
            if (typeId) {
                return instituteList.filter(institute => institute.office_type_id === typeId)
            }
            return instituteList
        },
        getData () {
            const tmpData = this.$store.state.list.find(item => item.id === this.id)
            return JSON.parse(JSON.stringify(tmpData))
        },
        getBookName (bookId) {
            const bookName = this.$store.state.DisabilitySchoolService.commonObj.libraryBookList.find(item => item.value === bookId)
            if (this.$i18n.locale === 'bn') {
                return bookName.text_bn
            } else {
                return bookName.text_en
            }
        },
        getOrgName (orgId) {
            const tmpData = this.$store.state.commonObj.organizationProfileList.find(item => item.value === orgId && item.status === 0)
            if (this.$i18n.locale === 'bn') {
                return tmpData.text_bn
            } else {
                return tmpData.text_en
            }
        },
        getInstituteType (Id) {
            const tmpData = this.$store.state.commonObj.officeTypeList.find(item => item.value === Id && item.status === 0)
            if (this.$i18n.locale === 'bn') {
                return tmpData.text_bn
            } else {
                return tmpData.text_en
            }
        },
        getOfficeName (officeId) {
            const officeName = this.$store.state.commonObj.officeList.find(item => item.value === officeId)
            if (this.$i18n.locale === 'bn') {
                return officeName.text_bn
            } else {
                return officeName.text
            }
        },
        getClassName (classId) {
            const ClassName = this.$store.state.DisabilitySchoolService.commonObj.classList.find(item => item.value === classId)
            if (this.$i18n.locale === 'bn') {
                return ClassName.text_bn
            } else {
                return ClassName.text
            }
        }
        // getStudentName (studentId) {
        //     const StudentName = this.applicantlist.find(item => item.value === studentId)
        //     if (this.$i18n.locale === 'bn') {
        //         return StudentName.name_bn
        //     } else {
        //         return StudentName.name_en
        //     }
        // }
    }
}
</script>
